module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"email":"Email","permission":"I consent to the storage and processing of my","personalData":"personal data","continue":"Continue"}}')
  delete Component.options._Ctor
}
